
export enum ProPrintedLabelStatusCd {
	ASSIGNED = 'Assigned',
	IN_WAREHOUSE = 'InWarehouse',
	PRINT_ORDERED = 'PrintOrdered',
	SHIPPED = 'Shipped'}

